import { compact, isEmpty } from 'lodash';

import { NOT_AVAILABLE } from 'enums/SigManagement.enum';

/**
 * The packaging line under a catalog item's name: strength, form and pack size.
 *
 * One definition, because the picker, the association list and the pending-changes summary all show
 * the same item and two of them disagreeing about what it is defeats the point of naming it. Each
 * part is optional on a catalog row, and a missing one reads as NA rather than as a gap — a blank
 * looks like a rendering fault, and the difference between "no form recorded" and "we failed to
 * render the form" matters to whoever has to go and fix the catalog.
 */
const describeCatalogItem = ({ strength, form, packSizeValue, packSizeUnit } = {}) => {
  const packSize = compact([packSizeValue, packSizeUnit]).join(' ');

  return [strength, form, packSize]
    .map((part) => (isEmpty(part) ? NOT_AVAILABLE : part))
    .join(' · ');
};

export default describeCatalogItem;
